// extracted by mini-css-extract-plugin
export default {"container":"steps_container__nfW4Q","imageContainer":"steps_imageContainer__NHp2Z","counter":"steps_counter__-vq0G"};